// Sombras do DS do Claude Design (docs/design-system/tokens/effects.css): só em
// camadas flutuantes, difusas e sempre em D900 com alfa. Compartilhadas entre o
// tema (escala `shadow="…"` do Mantine) e as CSS vars `--sa-shadow-*`.

const INK = "5, 4, 30"; // D900

export const SA_SHADOWS = {
  knob: `0 1px 3px rgba(${INK}, 0.28)`,
  segment: `0 1px 3px rgba(${INK}, 0.12)`,
  tooltip: `0 8px 20px rgba(${INK}, 0.22)`,
  toast: `0 10px 26px rgba(${INK}, 0.18)`,
  popover: `0 18px 40px rgba(${INK}, 0.18)`,
  // Popover do raio e lista `/` (SA-1426, `Atendimento.dc.html` L610 e L686).
  popoverLg: `0 18px 44px rgba(${INK}, 0.20)`,
  // Menu suspenso do cabeçalho da conversa (Transferir, protótipo
  // `Atendimento.dc.html`): 0 16px 40px, D900 a 18%.
  menu: `0 16px 40px rgba(${INK}, 0.18)`,
  // Formulário do dislike abaixo do balão da IA (SA-1485): 0 14px 36px, D900 a 16%.
  card: `0 14px 36px rgba(${INK}, 0.16)`,
  dialog: `0 24px 60px rgba(${INK}, 0.35)`,
  sheet: `0 26px 64px rgba(${INK}, 0.22)`,
} as const;
